import { render } from "./SitesPlanLockBadge.vue?vue&type=template&id=705c1396"
import script from "./SitesPlanLockBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./SitesPlanLockBadge.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Sites/SitesPlanLockBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "705c1396"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('705c1396', __exports__)) {
    api.reload('705c1396', __exports__)
  }
  
  module.hot.accept("./SitesPlanLockBadge.vue?vue&type=template&id=705c1396", () => {
    api.rerender('705c1396', render)
  })

}


export default __exports__